<template>
	<div class="pick-list-box">
		<div class="top-header">
			<el-button type="primary" size="medium" @click="handleDownload">{{$t('other.a938')}}</el-button>
			<el-button size="medium" type="primary" v-print="'#printTest'" >{{$t('other.a342')}}</el-button>
		</div>
		<div id="printTest">
			<div>
			    <div class="pick-list-wrpper">
					<div class="print-area" v-if="listCopy.length">
						 <div style="margin-bottom: 20px;">
							 <div style="display: flex;justify-content: space-between;">
								 <h2 @click="kkk">Picklist</h2>
							 </div>
							 <div class="uui" >total：{{listCopy.length}}</div>
							 <div class="uui">print-time：{{getTime()}}</div>
						 </div> 
						 <div ref="itemPage" class="ttp-box"  v-for="(item,index) in listCopy" :key="index">
							<div style="font-size: 16px;padding:3px 10px;">Order ID：{{item.orderId}}
								<span style="margin-left: 30px;">Package 1</span>
								<span style="margin-left: 30px;">Platform：{{item.platform}}</span>
							</div> 
							<div style="font-size: 14px;padding:2px 10px;">
								<span >Recipient：{{item.address.name}}</span>
								<span style="margin-left:20px">Phone：{{item.address.phone}}</span>
								<span style="margin-left:20px">Postcode：{{item.address.zipcode}}</span>
							</div>

							<div v-if="item.sender "  style="font-size: 14px;padding:2px 10px;">
								<span >sender：{{item.sender.state}}/{{item.sender.city}}/{{item.sender.address}}</span>
								
							</div>
							
							<div class="print-content">
								<span style="width: 30px;margin-left:15px" >#</span>
								<span class="pp-print">picture</span>
								<span class="pp-print">cusCode</span>
								<span class="pp-print">W_sku</span>
								<span class="pp-print">Position</span>
								<span class="pp-print">desc</span>
								<span class="pp-print">Qty</span>
							</div>
				


							<div  class="pp-wrapper"  v-for="(ccp,indexTwo) in item.itemsCopy"  :key="indexTwo">
								<span style="width: 30px;" class="pp-print" >{{indexTwo+1}}</span>
								
								<div>
									<div style="padding:3px 0" v-for="(oop,index03) in ccp" :key="index03">
										<span class="item_order_pic">
											<img :src="oop.image" />
										</span>
										<span class="item_order_desc">{{oop.cusCode}}</span>
										<span class="item_order_desc">{{oop.skuName !== $t('other.a354') ? oop.skuName : oop.variationSku}}</span>

										<span class="item_order_desc">{{oop.address}}</span>
										<span v-if="!oop.addition" class="item_order_desc">{{oop.isComponent ? 'General('+$t('other.a251')+')' : "Combination Set("+$t('other.a252')+")"}}</span>
										<span v-if="oop.addition" class="item_order_desc"> {{$t('other.a497')}}</span>
										<span  class="item_order_desc">{{oop.rate * oop.purchaseNum}}</span>
										
									</div>
								</div>
							</div>


						
						 </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import utils from '../../../../utils/utils'
import api from '../../../../api/api'
import orderApi from '../../../../api/moudles/order'
import newOrderApi from '../../../../api/moudles/newOrders'

	import {
		mapState,
	     mapActions,
	} from 'vuex'
	import loading from '../../../../components/loading.vue'
import shopaccess from '../../../../api/moudles/shopaccess'

	export default {
	    data() {
	      return {
	        picklist01:' ',
			picklist02:' ',
			pickData:[],
			pickingInfo:[],
			fields: ['订单号','运单号','付款方式','买家总付款','国家','省','市','详细地址','邮编','产品名称','属性SKU','商品Sku','数量','单价','快递方式','收件人电话','收件人','下单时间'],
			arr:[],
			addressList:[],
			calNum:0,
			listCopy:[]
		  }
	    },
		inject:['reload'],
		components:{
			loading
		},
		computed:{
			...mapState({
				picklist: state => state.order.picklist,
				seller: state => state.login.userInfo.userId,
				storeItemsData: state => state.order.storeItemsData,
			}),  
			
		},

		watch:{
			
		},


		created(){
			this.getOrdersByOrderId()
	
			
		},
	
		methods:{
			...mapActions('order', [
				'getUnprocessOrder',//获取所有商店待处理订单
				'auditOrder',
				'getPrintOrder', //打印订单
				'getOrdersBytrickNo',
				'queryAllOrder'
			]),

			

			kvnfknv(obj){
				console.log(obj)
				console.log(4545)
				shopaccess
				.getShopAddress(obj)
				.then(res => {
					console.log(res)
				if(res.code === 200 ){
				console.log('地址',res.data)
				if(res.data.response.address_list && res.data.response.address_list.length>0){
					res.data.response.address_list.forEach(p => {
						if(p.address_type.includes('default_address') || p.address_type.includes('pickup_address')){
							p.shopId=obj.shopId
							this.addressList.push(p)
						}
					})
				}
			
				if(!this.addressList.length){
					this.listCopy=this.arr
				}

				if(this.calNum == this.addressList.length){
					console.log('addressList',this.addressList)
					this.arr.forEach(p => {
						p.sender=null
						let num=this.addressList.find(item => item.shopId === p.shopId)
						if(num){
							p.sender=num
						}
					})

					this.listCopy=this.arr

					console.log('this',this.arr)
				}else{
					this.listCopy=this.arr
				}

				
				
				}else{
				this.$message.warning(res.msg)
				
				}

				})
			},
			
			
			getOrdersByOrderId(){
				let list=JSON.parse(localStorage.getItem('picklistInfoCopy'))
                newOrderApi
                .getOrderPDF(list)
                .then(res => {
                if(res.code === 200 ){
                console.log('desc',res.data)
                this.init(res.data)
				let obj={}
				let listOrder=[]
				this.arr.forEach(p => {
					if(!obj[p.shopId]){
						listOrder.push({
							shopId:p.shopId,
							userId:JSON.parse(localStorage.getItem('userInfo')).userId
						})
						obj[p.shopId]=true
					}
				})
				console.log('listOrder',listOrder)
				if(listOrder){
					listOrder.forEach(p => {
						this.calNum++
						this.kvnfknv(p)
					})
				}
                }else{
                this.$message.warning(res.msg)
                }
                })
                this.init(list)	
			},

            init(listData){
				this.arr=listData
				console.log(listData)
				console.log('-----')
				this.arr.forEach(p => {
				  let list3=[]
					p.itemsCopy=[]
					if(p.items.length > 0){
						p.items.forEach(k => {
							if(!k.storeItem || !k.storeItem.children  ||  k.storeItem.component){//判断items里的每个item是不是套餐，不是才push	
								k.cusCode=k.storeItem ? k.storeItem.cusCode : this.$t("other.a354")
								k.skuName=k.storeItem ? k.storeItem.skuName : this.$t("other.a354")
								k.address=k.storeItem ? k.storeItem.address : this.$t("other.a354")
								k.purchaseNum=k.variationQuantityPurchased
								k.rate=1
								p.itemsCopy.push([k])
								k.isComponent=true
						    }	
							if(k.storeItem && k.storeItem !== null){
								if(k.storeItem.additions.length> 0){
									let arr2=[]
									k.storeItem.additions.forEach(p => {
										p.purchaseNum=k.variationQuantityPurchased
										arr2.push(p)
									})

									list3.push(arr2)
								}
							}
							if(k.storeItem && k.storeItem !== null && k.storeItem.children){
								if(k.storeItem.children.length>0 && !k.storeItem.component){
									k.isComponent=false
									let list2=[]
									k.storeItem.children.forEach(i => {
										i.purchaseNum=k.variationQuantityPurchased
										list2.push(i)
									})
									list3.push(list2)
								}
							}
						})
					}

					if(list3.length){
						list3.forEach(i => {
							p.itemsCopy.push(i)
						})
					}
						
				})

				
				
				console.log('arr2',this.arr)
				console.log('listCopy',this.listCopy)
				// this.listCopy=this.arr
				
				
				
				
			},



		

	
			
			handleDownload () {
				console.log(this.arr)
				let arr=[]
				this.arr.forEach(p => {
					p.items.forEach((k,index) => {
						k.totalSku=''
						k.totalQty=0
						let num=index+1
						if(k.storeItem.component ){//单品
							k.totalSku='sku1'+':' +k.storeItem.skuName  + ' */Qty:' + k.variationQuantityPurchased
							k.totalQty=k.variationQuantityPurchased
						}else{//套餐
							k.storeItem.children.forEach((j,ttb )=> {
								let vdf=ttb+1
								k.totalSku+='sku'+ vdf + '('+ j.cusCode +')' + ':' +j.skuName  + ' */Qty:' + k.variationQuantityPurchased *j.rate
								k.totalQty+=j.rate*k.variationQuantityPurchased
							})
						}

						arr.push({
							'订单号':p.orderId,
							'运单号':p.trackingNo,
							'收货人':p.address.name,
							'电话号码':p.address.phone,
							'详细地址':p.address.state + '/' + p.address.city + '/' +p.address.fullAddress,
							'产品名称':k.itemName,
							'单品或套餐':k.storeItem.component ? this.$t('other.a251')+k.storeItem.cusCode : this.$t('other.a252') + k.storeItem.cusCode,
							'sku详情':k.totalSku,
							'sku数量':k.storeItem.component ? 1 : k.storeItem.children.length,
							'购买总数':k.totalQty,
							'实收':k.price,
							'配送方式':p.logistics,
							'下单时间':utils.renderTime(p.createTime),
						})
					})
				})

				let list=['订单号','运单号','收货人','电话号码','详细地址','产品名称','单品或套餐','sku详情','sku数量','购买总数','实收','配送方式','下单时间']
				console.log('arr',arr)
				utils.exPortEXml(arr,list,list)
				
			},



						
	
			
		
	
	
			changeImgURL(url){
				return url
							
			},
			getTime(){
				let  date=new Date();
				let  newdate=date.toLocaleString('chinese', { hour12: false });
				return newdate
			},
			kkk( array ) {
				console.log(this.picklist)
				this.nnm()
				
			},
			nnm(){
				let pp=[]
				let tempArr=[]
				let Data=[]
				let csvlist=[]
				this.pickingInfo.forEach(p => {
					p.items.forEach(i => {
						csvlist.push(i)
						i.phone=p.buyerPhone
						i.name=p.buyerName
						i.state=p.flagId
						i.city=p.flagId
						i.trackingNo=p.trackingNo
						i.country=p.flagId
						i.paymentMethod=p.flagId
						i.shippingCarrier=p.logistics
						i.fullAddress=p.flagId
						i.zipcode=p.flagId
						i.createTime=p.createTime
						i.totalAmount=p.flagId
						i.note=p.note
						i.messageToSeller=p.messageToSeller
						i.skuName=p.skuName,
						i.num =p.variationQuantityPurchased
						
					})
				})
				let ttp=csvlist.map(p => {
					return {
						'订单号':p.ordersn,
						'运单号':p.trackingNo,
						'付款方式':p.paymentMethod,
						'单价':p.variationDiscountedPrice,
						'数量':p.variationQuantityPurchased,
						'买家总付款':p.totalAmount,
						'国家':p.country,
						'省':p.state,
						'市':p.city,
						'详细地址':p.fullAddress,
						'邮编':p.zipcode,
						'产品名称':p.itemName,
						'属性SKU':p.variationSku,
						'商品Sku':p.itemSku,
						'快递方式':p.shippingCarrier,
						'收件人电话':p.phone,
						'收件人':p.name,
						'下单时间':p.createTime,	
					}
				})
				this.pickingInfo.forEach(item => {
					item.items.forEach(p => {
						pp.push(p)
					})
				})

				
				
				
				for (let i = 0; i < pp.length; i++) {
				   if (!tempArr.includes(pp[i].ordersn)) {
				     Data.push({
						ordersn:pp[i].ordersn,//订单号
						shippingCarrier:pp[i].shippingCarrier,//订单号
						trackingNo:pp[i].trackingNo,//订单号
						country:pp[i].country,//国家
						state:pp[i].state,//国家
						fullAddress:pp[i].fullAddress,//国家
						zipcode:pp[i].zipcode,
						paymentMethod:pp[i].paymentMethod,
						phone:pp[i].phone,
						recipient:pp[i].name,
						itemName: pp[i].itemName,
						image:pp[i].image,
						itemSku:pp[i].itemSku,
						dataInfo: [pp[i]],
						note:pp[i].note,
						messageToSeller:pp[i].messageToSeller,
						skuName:pp[i].storeItem ? pp[i].storeItem.skuName : this.$t("other.a140"),
						num:pp[i].variationQuantityPurchased
				     });
				     tempArr.push(pp[i].ordersn);
				   } else {
				     for (let j = 0; j < Data.length; j++) {
				       if (Data[j].ordersn == pp[i].ordersn) {
				         Data[j].dataInfo.push(pp[i]);
				         break;
				       }
				     }
				   }
				 }

				
				 
				 Data.forEach((p) => {
					let list=[]
					 p.isComponent=false
					 p.dataInfoCopy=[]
					 p.dataInfo.forEach((k,index) => {

						 k.cusCode=k.storeItem ? k.storeItem.cusCode : k.itemSku
						 k.skuName=k.storeItem ? k.storeItem.skuName : k.variationSku
						 k.address=k.storeItem ? k.storeItem.address : this.$t("other.a354")
						 
						 k.purchaseNum=k.variationQuantityPurchased
						
						 k.rate=1

						  
						  if(!k.storeItem || !k.storeItem.children  ||  k.storeItem.component){//判断items里的每个item是不是套餐，不是才push
							   p.dataInfoCopy.push([k])
							   k.isComponent=true
						  }

						  if(k.storeItem !== null){//是套餐才执行
								 if(k.storeItem.children.length > 0 && !k.storeItem.components){
									k.isComponent=false
									let list2=[]
									k.storeItem.children.forEach(i => {
										i.purchaseNum=k.variationQuantityPurchased
										list2.push(i)
									})
									
									list.push(list2)
							 }
						 }


						  if(k.storeItem && k.storeItem !== null){//是否有赠品
								if(k.storeItem.additions.length> 0){
									let arr2=[]
									k.storeItem.additions.forEach(p => {
										p.purchaseNum=k.variationQuantityPurchased
										arr2.push(p)
									})
									
									list.push(arr2)
								}
							}
						
						 
					 })

					console.log('list',list) 
					if(list.length){
						list.forEach(j => {
							p.dataInfoCopy.push(j)
						})
					}
					
					

					 
				 })
				 console.log('Data',Data)
				 this.pickData=ttp
					return Data
				
			}	

			
		}
	  }
</script>

<style>
	.pick-list-box{
		position: absolute;
		justify-content: center;
		width: 100%;
		background: #fff;
		z-index: 99999;
	
	}

	.item_order_desc{
		display: inline-block;
		padding: 0 5px;
		
		word-break: break-all;
	}

	
	.item_order_desc:nth-child(3){
		display: inline-block;
		padding: 0 5px;
		width:100px;
		word-break: break-all;
	}

	.item_order_desc:nth-child(2){
		display: inline-block;
		padding: 0 5px;
		width:70px;
		word-break: break-all;
	}

	.item_order_desc:nth-child(4){
		display: inline-block;
		padding: 0 5px;
		width:100px;
		word-break: break-all;
	}

	.item_order_desc:nth-child(5){
		display: inline-block;
		padding: 0 5px;
		width:150px;
		word-break: break-all;
	}

	.item_order_pic{
		display: inline-block;
		padding-right: 30px;
		width:50px;
	}


	.top-header{
		position: relative;
		width: 800px;
		text-align: right;
		margin: 10px auto;
	
		
	}
	.pp-wrapper{
		display: flex;
		box-sizing: border-box;
		padding:3px 0;
		align-items: center;
		border-bottom: 1px solid #eee;
	}
	
	.pp-name{
		display:inline-block;
		width: 300px !important;
	}
	
	.ttp-box{
		margin-bottom: 15px;
		border: 1px solid #000;
	}
	
	.pick-list-wrpper{
		width: 100%;
		display: flex;
		justify-content: center;
		font-size: 12px;
	}

	.always{
		page-break-after:always
	}
	
	.print-area{
		width: 210mm;
		height: 100%;
		box-sizing: border-box;
		padding: 0 30px;
		margin-bottom: 200px;
		

	}
	.print-desc{
		display: flex;
		flex: 1;
		
	}
	.print_desc_list{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: 100%;
		border-bottom: 1px solid #000;
		
	}
	
	.print-content{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: 100%;
		border-bottom: 1px solid #000;
		margin-top:10px;
		font-size: 14px;
		font-weight: bold;
	}
	
	.print_pic{
		
		width: 50px;
		height: 50px;
	}
	img{
		width: 100%;
		height: 100%;
	}
	
	.oopf{
		display: flex;
		flex-direction: column;
	}
	
	.item_name{
		display: inline-block;
		width: 200px;
		
	}

	.itme_pic{
		display: inline-block;
		width: 50px;
		height: 50px;
	}
	.print_desc_item_content{
		display: flex;
		align-items: center;
	}
	.print_desc_item{
		display: inline-block;
		margin-left: 10px;
		width: 100px;
		word-break: break-word;
		text-align: center;
	}
	
	.ttp_index{
		display: inline-block;
		width: 2%;
		text-align: center;
	}
	.ordersn{
		width: 120px;
	}
	.print-content-item{
		display: inline-block;
		
		
	}
	.uui{
		font-size: 16px;
		padding: 2px 0;
	}
	
	.pp-print{
		display: inline-block;
		margin: 10px 10px;
		
		word-wrap: break-word;
	}


	.pp-print:nth-child(1){
		display: inline-block;
		margin: 10px 10px;
		width: 70px;
		word-wrap: break-word;
	}

	.pp-print:nth-child(2){
		display: inline-block;
		margin: 10px 10px;
		width: 60px;
		word-wrap: break-word;
	}

	.pp-print:nth-child(3){
		display: inline-block;
		margin: 10px 10px;
		width: 60px;
		word-wrap: break-word;
	}

	.pp-print:nth-child(4){
		display: inline-block;
		margin: 10px 10px;
		width: 50px;
		word-wrap: break-word;
	}

		.pp-print:nth-child(6){
		display: inline-block;
		margin: 10px 10px;
		width: 70px;
		word-wrap: break-word;
		text-align: right;
	}
	.pp-print:nth-child(5){
		display: inline-block;
		margin: 10px 10px;
		width: 90px;
		word-wrap: break-word;
		text-align: right;
	}
	.pp-print:nth-child(6){
		display: inline-block;
		margin: 10px 10px;
		width: 90px;
		word-wrap: break-word;
		text-align: right;
	}
	.pp-print:nth-child(7){
		display: inline-block;
		margin: 10px 10px;
		width: 100px;
		word-wrap: break-word;
		text-align: right;
	}
	
	
	
	
	
	
	
	
</style>
